export default __webpack_public_path__ + "static/media/Insurance.15e41719.pdf";